import { createSlice } from '@reduxjs/toolkit';

const initialState = {  
    activeObj:{}, 
    iwuaObj:{},
    iwuaCommunityObj:{},
    iwuaPrivateObj:{},
    iwuaAsalObj:{},
    
};

export const objSlice = createSlice({
    name: 'obj',
    initialState,
    reducers: {
        // setActiveObj: (state, action) => {
        //     state.activeObj = action.payload;
        // },
        setActiveObj: (state, action) => {
            const { key, data } = action.payload;
            state.activeObj[key] = data;  
        },
        setIwuaObj: (state, action) => {
            state.iwuaObj = action.payload;
        },
        setIwuaCommunityObj: (state, action) => {
            state.iwuaCommunityObj = action.payload;
        },
        setIwuaPrivateObj: (state, action) => {
            state.iwuaPrivateObj = action.payload;
        },
        setIwuaAsalObj: (state, action) => {
            state.iwuaAsalObj = action.payload;
        },
        
        // clearActiveObj: (state, action) => {
        //     const { key } = action.payload;
        //     if (key) {
        //         delete state.activeObj[key];  
        //     } else {
        //         state.activeObj = {};  
        //     }
        // },
       
        clearObj: () => {
            return { ...initialState };
        },
       
    },
});

export default objSlice.reducer;
export const { setActiveObj, setIwuaObj,setIwuaCommunityObj,setIwuaPrivateObj,setIwuaAsalObj,clearObj,clearActiveObj } = objSlice.actions;
